import axios from "axios";
import { BASE_URL } from "../../../Helper/Helper";
const DataState = {
  addData: async (requestOptions) => {
    // FETCH API CALL For all notes
    const response = await axios.post(
      `${BASE_URL}/api/v2/admin/create-data`,
      requestOptions,
      {
        headers: {
          token: localStorage.getItem("token"),
        },
      }
    );

    // console.log("response", response);
    let datas = response.data;
    // console.log("datas", datas);
    return datas;
  },

  getData: async (params) => {
    const response = await axios.get(`${BASE_URL}/api/v2/admin/get-data`, {
      params,
      headers: {
        token: localStorage.getItem("token"),
      },
    });

    // console.log("data-state-res---", response);
    let datas = response.data;
    // console.log("datas", datas);
    return datas;
  },

  getDataById: async (id) => {
    // FETCH API CALL For all notes
    const response = await axios.get(
      `${BASE_URL}/api/v2/admin/getbyid-data/${id}`,
      {
        headers: {
          token: localStorage.getItem("token"),
        },
      }
    );

    // console.log("response", response);
    let datas = response.data.data;
    // console.log("datas", datas);
    return datas;
  },

  deleteData: async (id) => {
    const response = await axios.delete(
      `${BASE_URL}/api/v2/admin/delete-data/${id}`,
      {
        headers: {
          token: localStorage.getItem("token"),
        },
      }
    );

    let datas = response.data;
    // console.log("datas", datas);
    return datas;
  },

  updateData: async (id, requestOptions) => {
    // FETCH API CALL For all notes
    const response = await axios.post(
      `${BASE_URL}/api/v2/admin/update-data/${id}`,
      requestOptions,
      {
        headers: {
          token: localStorage.getItem("token"),
        },
      }
    );

    // console.log("res", response);
    let datas = response.data;
    // console.log("datas", datas);
    return datas;
  },

  updateDataById: async (id, updatedFiles) => {
    // FETCH API CALL For all files
    const response = await axios.post(
      `${BASE_URL}/api/v2/admin/single-data/${id}`,
      updatedFiles,
      {
        headers: {
          token: localStorage.getItem("token"),
        },
      }
    );
    let datas = response.data;
    // console.log("datas", datas);
    return datas;
  },

  updateDataStatus: async (id, requestOptions) => {
    // FETCH API CALL For all notes
    const response = await axios.post(
      `${BASE_URL}/api/v2/admin/data-status/${id}`,
      requestOptions,
      {
        headers: {
          token: localStorage.getItem("token"),
        },
      }
    );

    let datas = response.data;
    // console.log("datas", datas);
    return datas;
  },

  updateDataTags: async (id, requestOptions) => {
    // FETCH API CALL For all notes
    const response = await axios.post(
      `${BASE_URL}/api/v2/admin/data-tags/${id}`,
      requestOptions,
      {
        headers: {
          token: localStorage.getItem("token"),
        },
      }
    );

    let datas = response.data;
    // console.log("datas", datas);
    return datas;
  },

  updateDataTabStatus: async (id, requestOptions) => {
    // FETCH API CALL For all notes
    const response = await axios.post(
      `${BASE_URL}/api/v2/admin/data-tab-status/${id}`,
      requestOptions,
      {
        headers: {
          token: localStorage.getItem("token"),
        },
      }
    );

    let datas = response.data;
    // console.log("datas", datas);
    return datas;
  },

  updateDataTabNotes: async (id, requestOptions) => {
    // FETCH API CALL For all notes
    const response = await axios.post(
      `${BASE_URL}/api/v2/admin/data-tab-notes/${id}`,
      requestOptions,
      {
        headers: {
          token: localStorage.getItem("token"),
        },
      }
    );

    let datas = response.data;
    // console.log("datas", datas);
    return datas;
  },

  updateDataShareCount: async (id, requestOptions) => {
    // FETCH API CALL For all notes
    const response = await axios.post(
      `${BASE_URL}/api/v2/admin/data-share/${id}`,
      requestOptions,
      {
        headers: {
          token: localStorage.getItem("token"),
        },
      }
    );

    let datas = response.data;
    // console.log("datas", datas);
    return datas;
  },

  getFollowDataByDataId: async (id) => {
    // FETCH API CALL For all notes
    const response = await axios.get(
      `${BASE_URL}/api/v2/admin/getfollow-data/${id}`,
      {
        headers: {
          token: localStorage.getItem("token"),
        },
      }
    );

    // console.log("response", response);
    let datas = response.data;
    // console.log("datas", datas);
    return datas;
  },
};

export default DataState;
